import { render, staticRenderFns } from "./NirCompensationAgreementCard.vue?vue&type=template&id=23adf466&scoped=true"
import script from "./NirCompensationAgreementCard.vue?vue&type=script&lang=js"
export * from "./NirCompensationAgreementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23adf466",
  null
  
)

export default component.exports